var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import { stringifyParams, withTransformResponse } from '../../lib/utils';
import { makeAndFiltersForQuery, makeNegativeFilterForQuery, makeOrFiltersForQuery } from '../../lib/filter';
import { makeFacetsForQuery } from '../../lib/facet';
/**
 * Interceptor to normalize slots data.
 *
 * @param response the axios response
 *
 * @category Query Functions - getSlots
 * @category Interceptor Functions
 */
export const normalizeSlotsResData = (data) => {
    // `es_response_time` is not used by clients
    delete data.es_response_time;
    // `suggestion_details` is not populated for slots responses
    delete data.suggestion_details;
    return data;
};
export const transformGetSlotsInputForApi = (input) => {
    const params = {};
    const { facet, filter } = input, inputMinusFacetFilter = __rest(input, ["facet", "filter"]);
    if (filter === null || filter === void 0 ? void 0 : filter.and) {
        params.filter = makeAndFiltersForQuery(filter.and);
    }
    if (filter === null || filter === void 0 ? void 0 : filter.or) {
        params._filter = makeOrFiltersForQuery(filter.or);
    }
    if (filter === null || filter === void 0 ? void 0 : filter.not) {
        params['-filter'] = makeNegativeFilterForQuery(filter.not);
    }
    if (facet) {
        params.facet = makeFacetsForQuery(facet);
    }
    return Object.assign(Object.assign({}, params), inputMinusFacetFilter);
};
/**
 * Query function for retrieving appointment slots.
 *
 * @param client the internal client instance
 * @param config the internal client configuration object
 * @param input input parameters for paring down the search results
 *
 * @category Query Functions - getSlots
 * @category Query Functions
 */
export const getSlots = (client, config, input) => {
    const { customerCode } = config;
    return client.get(`/${customerCode}/slots`, {
        params: input,
        paramsSerializer: (params) => {
            const transformedParams = transformGetSlotsInputForApi(params);
            return stringifyParams(transformedParams);
        },
        transformResponse: withTransformResponse(client, [normalizeSlotsResData])
    });
};
//# sourceMappingURL=getSlots.js.map